export default "__VITE_ASSET__LIdDr9qE__"